const fuelTransactionsColumns = [
  { label: 'No (transaction)', value: 'uniqueId', disabled: true },
  { label: 'Type', value: 'type', disabled: false },
  { label: 'Flagged', value: 'flagged', disabled: false },
  { label: 'Date', value: 'timestamp', disabled: false },
  { label: 'Station', value: 'fuelStationBrandName', disabled: false },
  { label: 'Address', value: 'fuelStationAddress', disabled: false },
  { label: 'Plate', value: 'plate', disabled: false },
  { label: 'Code (trip)', value: 'code', disabled: false },
  { label: 'Code (user)', value: 'userReferralCode', disabled: false },
  { label: 'Merchant', value: 'merchantName', disabled: false },
  { label: 'Product', value: 'product', disabled: false },
  { label: 'Quantity', value: 'quantity', disabled: false },
  { label: 'Gross amount', value: 'amountTotal', disabled: false },
  { label: 'Fuel level', value: 'fuelLevel', disabled: false },
  { label: 'Net amount', value: 'netAmount', disabled: false },
  { label: 'VAT amount', value: 'vatAmount', disabled: false },
  { label: 'Fleet', value: 'fleetName', disabled: false },
  { label: 'Brand', value: 'brandId', disabled: false },
  { label: 'Merchant ID', value: 'merchantId', disabled: false },
];

const hiddenByDefault = [
  'netAmount',
  'vatAmount',
  'fleetName',
  'brandId',
  'merchantId',
];

export const defaultSelectedFuelTransactionsColumns = fuelTransactionsColumns
  .map((column) => column.value)
  .filter((value) => !hiddenByDefault.includes(value));

export default fuelTransactionsColumns;
